import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 跳转同路由解决
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) 
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 使用HTML5 History路由模式
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('../views/home.vue'),
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: () => import('../views/aboutCenter.vue')
    },
    {
      path: '/partner',
      name: 'Partner',
      component: () => import('../views/partnerCenter.vue')
    },
    {
      path: '/producter',
      name: 'Producter',
      meta: {
        title: '产品中心'
      },
      component: () => import('../views/productCenter.vue')
    },
    {
      path: '/case',
      name: 'Case',
      meta: {
        title: '成功案例'
      },
      component: () => import('../views/successCase.vue')
    }
  ],
});
